"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _react = _interopRequireWildcard(require("react"));

var _button = _interopRequireDefault(require("govuk-frontend/govuk/components/button/button"));

var _Link = require("../../../utils/Link");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Button = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var element = props.element,
      href = props.href,
      to = props.to,
      isStartButton = props.isStartButton,
      disabled = props.disabled,
      className = props.className,
      preventDoubleClick = props.preventDoubleClick,
      name = props.name,
      type = props.type,
      children = props.children,
      attributes = _objectWithoutProperties(props, ["element", "href", "to", "isStartButton", "disabled", "className", "preventDoubleClick", "name", "type", "children"]);

  var buttonRef = ref || /*#__PURE__*/_react["default"].createRef();

  var el = '';

  var buttonAttributes = _objectSpread(_objectSpread({
    name: name,
    type: type
  }, attributes), {}, {
    'data-module': 'govuk-button'
  });

  var button;
  (0, _react.useEffect)(function () {
    new _button["default"](buttonRef.current).init();
  }, [buttonRef]);

  if (element) {
    el = element;
  } else if (href || to) {
    el = 'a';
  } else {
    el = 'button';
  }

  var iconHtml;

  if (isStartButton) {
    iconHtml = /*#__PURE__*/_react["default"].createElement("svg", {
      className: "govuk-button__start-icon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "17.5",
      height: "19",
      viewBox: "0 0 33 40",
      "aria-hidden": "true",
      focusable: "false"
    }, /*#__PURE__*/_react["default"].createElement("path", {
      fill: "currentColor",
      d: "M0 0h13l20 20-20 20H0l20-20z"
    }));
  }

  var commonAttributes = {
    className: "govuk-button ".concat(className || '').concat(disabled ? ' govuk-button--disabled' : '', " ").concat(isStartButton ? 'govuk-button--start' : ''),
    ref: buttonRef
  };

  if (preventDoubleClick) {
    buttonAttributes['data-prevent-double-click'] = preventDoubleClick;
  }

  if (disabled) {
    buttonAttributes = _objectSpread(_objectSpread({}, buttonAttributes), {}, {
      'aria-disabled': true,
      disabled: 'disabled'
    });
  }

  if (el === 'a') {
    var linkAttributes = _objectSpread(_objectSpread(_objectSpread({}, commonAttributes), {}, {
      role: 'button',
      draggable: 'false'
    }, attributes), {}, {
      'data-module': 'govuk-button',
      href: href,
      to: to
    });

    button = /*#__PURE__*/_react["default"].createElement(_Link.Link, linkAttributes, children, iconHtml);
  } else if (el === 'button') {
    button =
    /*#__PURE__*/
    // Disabling linting of button type, because the button _does_ have an explicit type
    // It is defined in the defaultProps of the component, which gets added
    // to the buttonAttributes. eslint fails to detect this, and so we need to
    // disable the linting rule
    //
    // eslint-disable-next-line react/button-has-type
    _react["default"].createElement("button", _extends({}, buttonAttributes, commonAttributes), children, iconHtml);
  } else if (el === 'input') {
    if (!type) {
      buttonAttributes.type = 'submit';
    }

    button = /*#__PURE__*/_react["default"].createElement("input", _extends({
      value: children
    }, buttonAttributes, commonAttributes));
  }

  return button;
});

exports.Button = Button;
Button.displayName = 'Button';